import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormikContext } from 'formik';
import InputField from '../../../../components/InputField';
import {
	useGetOfficeTypesQuery,
	useGetRolesQuery,
} from '../../../../store/apiSlices/recruitApiSlice';
import { setRecruitForm } from '../../../../store/reducers/recruitFormReducer';
import { RootState } from '../../../../store/store';
import { OfficeTypes, OfficerRoles } from '../../../../enums/enum';
import Dropdown from '../../../../components/Dropdown';

const Staff = () => {
	const dispatch = useDispatch();
	const { getFieldProps, getFieldMeta, getFieldHelpers } = useFormikContext();
	const addOrUpdateRecruit = useSelector(
		(state: RootState) => state.addOrUpdateRecruit,
	);
	const rolesMasterData = useGetRolesQuery(null);
	const officeTypesMasterData = useGetOfficeTypesQuery(null);

	useEffect(() => {
		if (
			!rolesMasterData.currentData?.value?.length ||
			!officeTypesMasterData.currentData?.value?.length ||
			!getFieldProps('general_details.role_id').value
		)
			return;
		const roles = rolesMasterData.currentData.value;
		const roleType = roles.find(
			(e) => e.id === getFieldProps('general_details.role_id').value,
		)?.value;
		if (roleType === OfficerRoles.branch) {
			const defaultOfficeType =
				officeTypesMasterData.currentData.value.find(
					(e) => e.value === OfficeTypes.singleLocation,
				)?.id;

			if (defaultOfficeType) {
				dispatch(
					setRecruitForm({
						...getFieldProps('').value,
						staff_details: {
							...getFieldProps('staff_details').value,
							staff_office_id: defaultOfficeType || null,
						},
					}),
				);
			}
		}
	}, [
		rolesMasterData.currentData,
		officeTypesMasterData.currentData,
		getFieldProps('general_details.role_id').value,
	]);

	useEffect(() => {
		if (
			getFieldProps('general_details.role_id')?.value ===
			OfficerRoles.loanOfficer
		) {
			getFieldHelpers('staff_details.staff_total').setValue('0');
			getFieldHelpers('staff_details.staff_lo').setValue('0');
			getFieldHelpers('staff_details.staff_closers').setValue('0');
			getFieldHelpers('staff_details.staff_loa').setValue('0');
			getFieldHelpers('staff_details.staff_underwriters').setValue('0');
			getFieldHelpers('staff_details.staff_office_id').setValue(null);
			getFieldHelpers('staff_details.staff_others').setValue('0');
			getFieldHelpers('staff_details.staff_processors').setValue('0');
		}
	}, [
		getFieldProps('general_details.role_id')?.value,
		getFieldProps('staff_details')?.value,
	]);

	useEffect(() => {
		let updatedTotal = 0;
		Object.entries(getFieldProps(`staff_details`).value).forEach((e) => {
			if (e[0] === 'staff_office_id' || e[0] === 'staff_total') return;
			updatedTotal = updatedTotal + Number(e[1]);
		});
		getFieldHelpers('staff_details.staff_total').setValue(
			updatedTotal.toString(),
		);
	}, [
		getFieldProps('staff_details.staff_others')?.value,
		getFieldProps('staff_details.staff_processors')?.value,
		getFieldProps('staff_details.staff_underwriters')?.value,
		getFieldProps('staff_details.staff_loa')?.value,
		getFieldProps('staff_details.staff_closers')?.value,
		getFieldProps('staff_details.staff_lo')?.value,
	]);

	return (
		<>
			{getFieldProps('general_details.role_id').value ===
			rolesMasterData.currentData?.value?.find(
				(e) => e.value === OfficerRoles.branch,
			)?.id ? (
				<div className="flex flex-col bg-white p-4 gap-y-4 rounded-lg">
					<div className="text-xl font-bold">Staff</div>
					<div className={`grid gap-4 grid-cols-2`}>
						<InputField
							name="staff_details.staff_total"
							isRequired={false}
							labelClassName={'col-span-2'}
							type="number"
							min={0}
							label="Total"
							disabled={true}
						/>

						<InputField
							name="staff_details.staff_lo"
							label="LOs"
							type="number"
							min={0}
							isRequired={false}
							placeholder="Enter LO's"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
						<InputField
							name="staff_details.staff_closers"
							isRequired={false}
							type="number"
							min={0}
							label="Closers"
							placeholder="Enter Closers"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>

						<InputField
							name="staff_details.staff_loa"
							type="number"
							min={0}
							label="LOAs"
							isRequired={false}
							placeholder="Enter LOA's"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
						<InputField
							name="staff_details.staff_underwriters"
							label="Underwriters"
							type="number"
							min={0}
							isRequired={false}
							placeholder="Enter Underwriters"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
						<InputField
							name="staff_details.staff_processors"
							label="Processors"
							type="number"
							min={0}
							isRequired={false}
							placeholder="Enter Processors"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
						<InputField
							name="staff_details.staff_others"
							label="Others"
							type="number"
							min={0}
							isRequired={false}
							placeholder="Enter Others"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
						<Dropdown
							label="Office"
							name="staff_details.staff_office_id"
							isRequired={false}
							placeholder="Select Office"
							list={
								officeTypesMasterData.currentData?.value || []
							}
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
					</div>
				</div>
			) : null}
		</>
	);
};
export default Staff;
